import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import { Component } from 'react';
import styled from 'styled-components';
import where from 'transmute/where';
import getIn from 'transmute/getIn';
import I18n from 'I18n';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIIcon from 'UIComponents/icon/UIIcon';
import UISelect from 'UIComponents/input/UISelect';
import { OBSIDIAN, EERIE } from 'HubStyleTokens/colors';
import { getInboxesCount } from 'conversations-internal-schema/inbox/operators/getInboxesCount';
import { getName, getId } from 'conversations-internal-schema/inbox/operators/inboxGetters';
import { trackEvent, trackEventBeforeUnload } from '../../usage-tracking/clients/usageTracker';
import { clickToChangeInbox, clickedInboxSettings
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledHeader = styled.h5.withConfig({
  displayName: "InboxSelect__StyledHeader",
  componentId: "xlk50p-0"
})(["color:", ";"], OBSIDIAN);
const CustomItemComponent = _ref => {
  let {
      children,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const finalChildren = /*#__PURE__*/_jsxs("div", {
    className: "nowrap display-flex align-center",
    children: [/*#__PURE__*/_jsx(UITruncateString, {
      tooltip: false,
      children: children
    }), /*#__PURE__*/_jsx("span", {
      children: option.isSelected && /*#__PURE__*/_jsx(UIIcon, {
        name: "success",
        style: {
          color: EERIE,
          marginRight: '1.2em'
        },
        size: 15
      })
    })]
  });
  const finalProps = Object.assign({}, rest, {
    children: finalChildren
  });
  return /*#__PURE__*/_jsx("li", Object.assign({}, finalProps));
};
CustomItemComponent.displayName = 'CustomItemComponent';
class InboxSelect extends Component {
  constructor(...args) {
    super(...args);
    this.handleClickInboxSettings = () => {
      trackEventBeforeUnload(clickedInboxSettings);
    };
    this.renderSelectValue = () => {
      const {
        currentInbox
      } = this.props;
      return /*#__PURE__*/_jsx(StyledHeader, {
        inboxName: getName(currentInbox),
        className: "m-all-0",
        children: /*#__PURE__*/_jsx(UITruncateString, {
          placement: "right",
          children: getName(currentInbox)
        })
      });
    };
    this.renderSingleHeader = () => {
      const {
        inboxes,
        currentInbox
      } = this.props;
      const inboxName = getInboxesCount(inboxes) === 1 ? getName(currentInbox) : I18n.text('conversations-inbox-ui.unified-inbox.header');
      return /*#__PURE__*/_jsx("div", {
        className: "width-100 height-100 align-end",
        children: /*#__PURE__*/_jsx(StyledHeader, {
          className: 'p-all-3 m-bottom-0',
          inboxName: inboxName,
          children: /*#__PURE__*/_jsx(UITruncateString, {
            placement: "right",
            children: inboxName
          })
        })
      });
    };
  }
  render() {
    const {
      inboxes,
      currentInbox,
      onInboxSelect,
      menuWidth,
      placement
    } = this.props;
    if (!currentInbox || getInboxesCount(inboxes) === 0 || getInboxesCount(inboxes) === 1) {
      return this.renderSingleHeader();
    }
    return /*#__PURE__*/_jsx(UISelect, {
      className: "selenium-test-marker-inbox-select-dropdown width-100",
      searchable: false,
      buttonUse: "transparent"
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      placement: placement,
      onOpenChange: evt => {
        const isOpen = getIn(['currentTarget', 'value'], evt);
        if (isOpen) {
          trackEvent(clickToChangeInbox);
        }
      },
      menuWidth: menuWidth,
      onChange: ({
        target: {
          value
        }
      }) => {
        const inbox = where({
          id: value
        }, inboxes).get(0);
        onInboxSelect(inbox);
      },
      valueComponent: this.renderSelectValue,
      itemComponent: CustomItemComponent,
      options: inboxes.map(inbox => ({
        text: getName(inbox),
        value: getId(inbox),
        isSelected: getId(inbox) === getId(currentInbox)
      })).toJS()
    });
  }
}
InboxSelect.displayName = 'InboxSelect';
InboxSelect.defaultProps = {
  onInboxSelect: () => {},
  placement: 'bottom right',
  menuWidth: 250
};
export default InboxSelect;